module.exports = __webpack_public_path__ + "media/images/icon-InfoVerification-329863e5.png";